import { AfterViewInit, Component, EventEmitter, Output } from '@angular/core';

import { FilesHelperService } from '@mirage-projects/cw-utils';

/** This component is used for upload and preview an image */
@Component({
    selector: 'cw-img-input-file',
    templateUrl: './input-img-file.component.html',
    styleUrls: ['./input-img-file.component.scss'],
    standalone: false,
})
export class InputImgFileComponent implements AfterViewInit {
    readonly IMG_NOT_AVAIBLE = 'assets/img/not-available.png';

    srcImg = this.IMG_NOT_AVAIBLE;
    isImageSetted = false;

    /**
     * Emits after set the image.
     */
    @Output() setImage = new EventEmitter<File>();

    /**
     * Emits after remove the image.
     */
    @Output() removeImage = new EventEmitter();

    constructor(private filesHelperService: FilesHelperService) {}

    ngAfterViewInit(): void {
        this.srcImg = this.IMG_NOT_AVAIBLE;
    }

    async onSetImage(files: File[]): Promise<void> {
        const file = files[0];
        this.srcImg = await this.filesHelperService.getImgUrlBase64FromFile(file);
        this.isImageSetted = true;
        this.setImage.emit(file);
    }

    onRemoveImage(): void {
        this.isImageSetted = false;
        this.srcImg = this.IMG_NOT_AVAIBLE;
        this.removeImage.emit();
    }
}
